import { useMutation } from '@redwoodjs/web';

import { INITIALISE_SAGE } from 'src/graphql/mutations/initiliseSage.mutation';
import { onError } from 'src/utils/utils';

export const useSageAuth = () => {
    const [initialiseSageMutation, { loading: loadingInitialiseSage }] = useMutation(
        INITIALISE_SAGE,
        {
            onError,
            onCompleted: (data) => {
                const redirectUrl = data?.initialiseSage;

                if (redirectUrl) {
                    window.location.href = redirectUrl;
                }
            },
        }
    );

    const handleSageLogin = () => {
        initialiseSageMutation();
    };

    return {
        handleSageLogin,
        loadingInitialiseSage,
    };
};
